import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy' 
import sortBy from 'lodash/sortBy'
import DayPickerRangeController from 'react-dates/lib/components/DayPickerRangeController'
import { updateCustomDateRange} from '../../actions/scoreSheet'
import Icon from '../../components/misc/Icons'

class CalNavButton extends React.Component{
	
	render(){
		
		return(
			<div className='scoreSheet-calendarNavCustom'>
				{this.props.previous && 
					<Icon name='chevron-left' />
				}
				{this.props.next && 
					<Icon name='chevron-right' />
				}
			</div>
		)
	}
}

 
class ScoreSheetSidePanelCalendar extends Component {
	
	constructor(props) {
		super(props)
		this.onDatesChange = this.onDatesChange.bind(this)
		this.startDateOffset = this.startDateOffset.bind(this)
		this.endDateOffset = this.endDateOffset.bind(this)
		this.isDayHighlighted = this.isDayHighlighted.bind(this)
		this.isOutsideRange = this.isOutsideRange.bind(this)

		let startDate=null
		let endDate=null
		if(props.dateRange){
			if(props.dateRange.startDate){
				startDate=props.dateRange.startDate
				endDate=props.dateRange.endDate
			}
	 }
		
		this.state = {
			focusedInput: 'endDate',
			startDate: startDate,
			endDate: endDate,
			initialVisibleMonth:endDate
		}
	}


	UNSAFE_componentWillReceiveProps(nextProps) {

 		if(nextProps.dateRange.startDate && nextProps.dateRange.startDate !== this.props.dateRange.startDate ){
 			this.setState({startDate:nextProps.dateRange.startDate,endDate:nextProps.dateRange.endDate,initialVisibleMonth:nextProps.dateRange.endDate})
 		}
 	}






	onDatesChange({ startDate, endDate }) {
		const {granularity}=this.props
		let realStartDate=startDate
		if(granularity==='14d'){  //because of offset thing for highlighting
			realStartDate=startDate.add(14,'days')
		}else if(granularity==='90d'){
			realStartDate=startDate.add(90,'days')
		}

		this.props.changeSelectedDate(null,realStartDate)
	}



	isDayHighlighted(day){
		if(this.props.dayGroupedPollsForSection[day.startOf('day')]){
			return true
		}else return false
	}

	isOutsideRange(day){
		if(day.isAfter(moment())//can only select dates in past
			//||
			//day.startOf('day').isBefore(moment(this.props.firstDataDate).startOf('day')) //Cant select dates before earliest minCaptured
		){
			return true
		}else return false
	}


	startDateOffset(day){
		const {granularity}=this.props
		if(granularity ==='day'){
			return day.startOf('isoDay')
		}else if(granularity ==='week'){
			return day.startOf('isoWeek')
		}else if(granularity==='month'){
			return day.startOf('month')
		}
		else if(granularity==='14d'){
			return day.subtract(14,'days')
		}
		else if(granularity==='90d'){
			return day.subtract(90,'days')
		}
	}

	endDateOffset(day){
		const {granularity}=this.props
		if(granularity ==='day'){
			return day.endOf('isoDay')
		}
		else if(granularity ==='week'){
			return day.endOf('isoWeek')
		}else if(granularity==='month'){
			return day.endOf('month')
		}
		else if(granularity==='14d'){
			return day
		}
		else if(granularity==='90d'){
			return day
		}


	}




	render() {
		return (
		 <div className="scoreSheetSidePanel-calendar">
		 	<div className="scoreSheetSidePanel-calendarInnerContainer">
					<DayPickerRangeController
						initialVisibleMonth={() => {return this.state.initialVisibleMonth}}
						key={this.props.currentSectionId}
						startDate={this.state.startDate} 
						endDate={this.state.endDate}
						firstDayOfWeek={1}
						onDatesChange={this.onDatesChange}
						focusedInput={'startDate'}
						//onFocusChange={this.onFocusChange}
						numberOfMonths={1}  
						isOutsideRange={this.isOutsideRange} 
						isDayHighlighted={ this.isDayHighlighted }
						hideKeyboardShortcutsPanel
						navPrev={<CalNavButton previous />}
						navNext={<CalNavButton next />}
						daySize={28}
						transitionDuration={0}
						weekDayFormat={'dd'}		
						enableOutsideDays={true}
						startDateOffset={this.startDateOffset}
						endDateOffset={this.endDateOffset}
					/>
				</div>
			</div>
		)
	}
}



function mapStateToProps(state,ownProps) {
	
	const currentSection=ownProps.currentSectionId
	const pollsForSection=filter(filter(state.historySetPolls,{archived:false}),{section:currentSection}).concat(filter(filter(state.historyQuestionPolls,{archived:false}),{section:currentSection}))
	const dayGroupedPollsForSection=groupBy(pollsForSection, function(poll) {
		return moment(poll.minCaptured).startOf('day')
	})
	const firstPoll=sortBy(pollsForSection, [function(poll) { 
		return poll.minCaptured
	}])[0]
	let firstDataDate

	if(firstPoll){
		firstDataDate=firstPoll.minCaptured
	}

	
	return {
		dayGroupedPollsForSection:dayGroupedPollsForSection,
		firstDataDate:firstDataDate
	}
}





export default connect(mapStateToProps,
	{updateCustomDateRange}
)(ScoreSheetSidePanelCalendar)


